import Select from "react-select";
import {  Tooltip } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Col, Row, Button, Form, Modal } from "react-bootstrap";
import CommonConfirmModel from "../../Model/CommonConfirmModel";

const ArticleView = ({ articleData = [], primaryLink, is_selectable, pdfSelected, onPdfToggle, deleteStatus, deleteContent, selectedSublink,setCurrentSelectedSublink ={} }) => {
    let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
    const [selectedSublinkId, setSelectedSublinkId] = useState(
        pdfSelected ? {[pdfSelected] : selectedSublink} :  {}
    );
    const [confirmationpopup, setConfirmationPopup] = useState(false);
    const [commonConfirmModelFun, setCommonConfirmModelFun] = useState(() => { });
    const [resetDataId, setResetDataId] = useState("");
    const [render, setRender] =  useState("");
    const [popupMessage, setPopupMessage] = useState({
        message1: "",
        message2: "",
        footerButton: "",
    });

    const handleSpcFun = (data) => {
        let newWindow = "";
        newWindow = window.open("/article_preview");
        newWindow.data = data;
    };

    const showConfirmationPopup = (stateMsg, id) => {
        if (stateMsg == "delete") {
            setResetDataId(id);
            setCommonConfirmModelFun(() => (id) => {deleteContent(id); setConfirmationPopup(false);});
            setPopupMessage({
                message1:
                "You are about to remove this content.",
                message2: "Are you sure you want to do this?",
                footerButton: "Yes please!",
            });
            if (confirmationpopup) {
                setConfirmationPopup(false);
            } else {
                setConfirmationPopup(true);
            }
        }
    };

    const hideConfirmationModal = () => {
        setConfirmationPopup(false);
    };

    function LinkWithTooltip({ id, children, href, tooltip }) {
        return (
        <OverlayTrigger
            overlay={<Tooltip id={id}>{tooltip}</Tooltip>}
            placement="top"
            delayShow={300}
            delayHide={150}
        >
            <a href={href}>{children}</a>
        </OverlayTrigger>
        );
    }

    const onSublinkChange = (id, selectedOption) => {
        const updatedSublinkId = selectedOption ? selectedOption.value : null;
        setSelectedSublinkId((prevState) => {
            const newState = { ...prevState, [id]: updatedSublinkId };
            return newState;
        });
        if (pdfSelected == id) {
            setCurrentSelectedSublink(selectedOption?.value);
        }
    };

    return (
        <>
            <Row>
                {
                    articleData?.length > 0 ?
                        articleData.map((data, index) => {
                            const sublinkOptions = [
                                { value: 0, label: "Primary link" },
                                ...(data?.sublinks?.map((item) => ({
                                  value: item.id,
                                  label: item.name,
                                })) || []), // Add this fallback empty array
                            ];
                            return (
                                <div className="col-12 col-md-4" key={index}>
                                    <div className="mail-content-select-box">
                                        <div className="mail-content-select-top">
                                            <div className="mail-preview-img">
                                                <img src={data.cover_img} alt="Preview " />
                                            </div>
                                            <div className="mail-box-content">
                                                <h5>{data.title}</h5>
                                                <p>{data.pdf_sub_title}</p>
                                                <div className="mailbox-tags">
                                                    <ul>
                                                             {localStorage.getItem("user_id") === "FOkB/AUT2wGXRv ablqvbg==" ? (
                                                                                                    (() => {
                                                                                                      const parseJSONSafe = (json) => {
                                                                                                        try {
                                                                                                          return JSON.parse(json) || [];
                                                                                                        } catch (e) {
                                                                                                          return [];
                                                                                                        }
                                                                                                      };
                                                                                                      const combinedTags = [
                                                                                                        ...(data?.tags ? parseJSONSafe(data.tags).map(tag => ({ type: "clinical", name: tag })) : []),
                                                                                                        ...(data?.functional_tags ? parseJSONSafe(data.functional_tags).map(tag => ({ type: "functional", name: tag })) : []),
                                                                                                      ];
                                                                                                      // ✅ Sort alphabetically by tag name
                                                                                                      const sortedTags = combinedTags.sort((a, b) => a.name.localeCompare(b.name));
                                                                                                      return sortedTags.map((tag, index) => (
                                                                                                        <li
                                                                                                          key={index}
                                                                                                          className={`list1 ${tag.type === "clinical" ? "clinical" : "functional"}`}
                                                                                                          title={tag.type === "clinical" ? "Clinical" : "Functional"}
                                                                                                        >
                                                                                                          {tag.name}
                                                                                                        </li>
                                                                                                      ));
                                                                                                    })()
                                                                                                  ) : data?.tags && data.tags != ""  ? (
                                                                                                                data.tags.map((tag, index) => {
                                                                                                                return <li key={index} className="list1">{tag}</li>;
                                                                                                            })
                                                                                                  ) : <li className="list1">N/A</li>}


                                                        {/* {data.tags != "" ? (
                                                            data.tags.map((tag, index) => {
                                                                return <li key={index} className="list1">{tag}</li>;
                                                            })
                                                        ) : (
                                                            <li className="list1">N/A</li>
                                                        )} */}
                                                    </ul>
                                                </div>
                                            </div>
                                            {
                                                is_selectable ?
                                                <div className="select-mail-option">
                                                    <input
                                                        type="checkbox"
                                                        name="article_select"
                                                        value={data.id}
                                                        checked={pdfSelected.includes(data.id) ? true : false}
                                                        onChange={() => {
                                                            onPdfToggle(data.id)
                                                            setCurrentSelectedSublink(selectedSublinkId[data.id])
                                                        }}
                                                    />
                                                    <span className="checkmark"></span>
                                                </div> : null
                                            }
                                        </div>

                                        <div className="mail-content-table">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <th>Upload date</th>
                                                        <td>{data.created}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Language</th>
                                                        <td>{data.language}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Last email</th>
                                                        <td>
                                                            {data.last_sent == ""
                                                                ? "N/A"
                                                                : data.last_sent}
                                                        </td>
                                                    </tr>
                                                    {
                                                    primaryLink == 1 && (
                                                    <tr>
                                                        <th>Link <LinkWithTooltip tooltip="This is the link you’ll include in the email—either the primary survey link or one of the subLinks.">
                                                            <img
                                                                src={
                                                                    path_image +
                                                                    "info_circle_icon.svg"
                                                                }
                                                                alt="Link"
                                                            />
                                                        </LinkWithTooltip></th>
                                                        <td><div className="select-dropdown-wrapper">
                                                        <div className="select">
                                                            <Select
                                                                aria-label="SSelect Sublink"
                                                                className="dropdown-basic-button split-button-dropup"
                                                                name="surveyCreator"
                                                                placeholder="Select link type"
                                                                onChange={(selectedOption) => {
                                                                    onSublinkChange(
                                                                        data.id,
                                                                        selectedOption
                                                                    );
                                                                }}
                                                                options={sublinkOptions}
                                                                value={sublinkOptions.find((option) => { return option.value === (selectedSublinkId[data.id] ?? 0) })}
                                                            />
                                                        </div>
                                                    </div></td>
                                                    </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* {
                                            primaryLink == 1 && (
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h6 className="tab-content-title">
                                                        Link
                                                        <LinkWithTooltip tooltip="This is the link you’ll include in the email—either the primary survey link or one of the subLinks.">
                                                            <img
                                                                src={
                                                                    path_image +
                                                                    "info_circle_icon.svg"
                                                                }
                                                                alt="Link"
                                                            />
                                                        </LinkWithTooltip>

                                                    </h6>
                                                    <div className="select-dropdown-wrapper">
                                                        <div className="select">
                                                            <Select
                                                                aria-label="SSelect Sublink"
                                                                className="dropdown-basic-button split-button-dropup"
                                                                name="surveyCreator"
                                                                placeholder="Select link type"
                                                                onChange={(selectedOption) => {
                                                                    onSublinkChange(
                                                                        data.id,
                                                                        selectedOption
                                                                    );
                                                                }}
                                                                options={sublinkOptions}
                                                                value={sublinkOptions.find((option) => { return option.value === (selectedSublinkId[data.id] ?? 0) })}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        } */}
                                        {
                                            !deleteStatus && (
                                                <div className="mail-content-footer">
                                                    {
                                                        data?.spc_included ?
                                                            <button className="btn btn-primary btn-filled" onClick={() =>
                                                                handleSpcFun(data?.spc_url)
                                                            }>
                                                                Preview
                                                            </button>
                                                            :
                                                            <a href={data.preview_link} target="_blank">
                                                                <button className="btn btn-primary btn-filled">
                                                                    Preview
                                                                </button>
                                                            </a>
                                                    }

                                                </div>
                                            )
                                        }
                                        {
                                            deleteStatus && (
                                                <div className="dlt_btn">
                                                <button onClick={(e) => showConfirmationPopup("delete",data.id)}>
                                                   
                                                    <img src={path_image + "delete.svg"} alt="Delete Row"/>
                                                </button>
                                            </div>
                                            )
                                        }
                                    </div>
                                </div>
                            );
                        })
                        : null
                }
            </Row>

            <CommonConfirmModel
                show={confirmationpopup}
                onClose={hideConfirmationModal}
                fun={commonConfirmModelFun}
                popupMessage={popupMessage}
                path_image={path_image}
                resetDataId={resetDataId}
                onCloseCross={hideConfirmationModal}
            />
        </>
    );
}

export default ArticleView;